import { render, staticRenderFns } from "./LowerFooter.vue?vue&type=template&id=749aef64"
import script from "./LowerFooter.vue?vue&type=script&lang=js"
export * from "./LowerFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports